import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  phone: "(513) 260-0899",
  email: "BriarsUnlimited@gmail.com",
  location: "Middletown, New Jersey",
  hours: "Mon – Fri: 9AM – 5PM",
  instagram: "briars_unlimited",
  show_prices: false,
  store_name: "Spirit Store",
  store_active: true,
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = () => {
    api.get("/settings")
      .then(({ data }) => setSettings({ ...DEFAULTS, ...data }))
      .catch(() => {});
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
